import { paginationElementClassName } from './index';

export const verticalPromoSlides = {
    slidesPerView: 2,
    breakpoints: {
        560: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        },
        1500: {
            slidesPerView: 5,
        },
    },
};

export const swiperSettings = (language: string) => {
    return {
        swiperSettings: {
            autoplay: false,
            freeMode: false,
            loop: false,
            slidesPerView: 1,
            slidesPerGroup: 1,
            breakpoints: {
                560: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
            },
            dir: language === 'ar' ? 'rtl' : 'ltr',
            pagination: {
                el: `.${paginationElementClassName}`,
                clickable: true,
            },
        },
    };
};
